var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rider-receipt-mgmt"},[(_vm.activeTab === 'template')?_c('receipt-settings'):_c('receipt-custom-print')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }